var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import FeaturePickingTraits from "./FeaturePickingTraits";
import { GeoJsonTraits } from "./GeoJsonTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import { MinMaxLevelTraits } from "./MinMaxLevelTraits";
import UrlTraits from "./UrlTraits";
let ArcGisFeatureServerCatalogItemTraits = (_dec = traitClass({
  description: "Creates a single item in the catalog from one ESRI Feature Server layer.\n\n  <strong>Note:</strong> <i>Must specify <b>layer ID</b>, e.g. <code>/0</code>, in the URL path.</i>\n\n  Some traits are only relevant when the service supports tiling (see `tileRequests` trait).",
  example: {
    url: "https://services5.arcgis.com/OvOcYIrJnM97ABBA/arcgis/rest/services/Australian_Public_Hospitals_WFL1/FeatureServer/0",
    type: "esri-featureServer",
    name: "Australian Public Hospitals",
    id: "some id"
  }
}), _dec2 = primitiveTrait({
  name: "Token URL",
  description: "URL to use for fetching request tokens. Note this will override the token trait if both are set.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Token",
  description: "Token to use for ArcGiS REST API requests (if not using tokenUrl)",
  type: "string"
}), _dec4 = primitiveTrait({
  type: "boolean",
  name: "Clamp to Ground",
  description: "Whether the features in this service should be clamped to the terrain surface."
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Use style information from service",
  description: "Whether to symbolise the data using the drawingInfo object available in the service endpoint."
}), _dec6 = primitiveTrait({
  type: "string",
  name: "layerDef",
  description: "DEPRECATED, use `where` instead. The 'layerDef' string to pass to the server when requesting geometry."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "Where clause",
  description: "The 'where' string to pass to the server when requesting geometry."
}), _dec8 = primitiveTrait({
  type: "number",
  name: "Maximum features",
  description: "The maximum number of features to be retrieved from the feature service."
}), _dec9 = primitiveTrait({
  type: "number",
  name: "Features per request",
  description: "The number of features to be retrieved from the feature service in each request. This should be equal to the " + "maxRecordCount specified by the server."
}), _dec0 = primitiveTrait({
  type: "boolean",
  name: "Supports pagination",
  description: "Whether this feature service supports pagination. By default, this will be inferred from the server's response."
}), _dec1 = primitiveTrait({
  type: "boolean",
  name: "Tile requests",
  description: "Whether this feature service supports tiled requests. This will be true by default, if the server supports tiling and no unsupported Point/Label/Trail styles are used (for example custom marker images)"
}), _dec10 = primitiveTrait({
  type: "boolean",
  name: "Clip tile requests to rectangle",
  description: "Gets or sets a value indicating whether this dataset should be clipped to the {@link CatalogItem#rectangle}.\nIf true, no part of the dataset will be displayed outside the rectangle.\nThis property is true by default, leading to better performance and avoiding tile request errors that might occur when requesting tiles outside the server-specified rectangle.\nHowever, it may also cause features to be cut off in some cases, such as if a server reports an extent that does not take into account that the representation of features sometimes require a larger spatial extent than the features themselves.\nFor example, if a point feature on the edge of the extent is drawn as a circle with a radius of 5 pixels, half of that circle will be cut off."
}), _dec11 = primitiveTrait({
  type: "number",
  name: "Maximum features",
  description: "For each tile, the maximum number of features to be retrieved from the feature service. This will limit the number of requests, each request uses featuresPerTileRequest trait."
}), _dec12 = primitiveTrait({
  type: "number",
  name: "Features per request",
  description: "The number of features to be retrieved from the feature service in each request. This should be equal to the " + "tileMaxRecordCount specified by the server."
}), _dec13 = primitiveTrait({
  type: "number",
  name: "maxRecordCountFactor",
  description: "When set, the maximum number of features returned by the query will equal the maxRecordCount of the service multiplied by this factor. This only applies to tiled requests. This will use the server's default value."
}), _dec14 = primitiveTrait({
  type: "boolean",
  name: "Tile requests",
  description: "Whether this feature service supports tiled requests. By default, this will be inferred from the server's response."
}), _dec15 = primitiveTrait({
  type: "string",
  name: "Object ID Field",
  description: "The field in the feature service that contains the unique identifier for each feature."
}), _dec16 = primitiveArrayTrait({
  type: "string",
  name: "Out Fields",
  description: "The fields to be included in the response from the feature service. This will default to the object ID field, and include any fields required for styling. Currently, this only applies to tiled requests."
}), _dec(_class = (_class2 = class ArcGisFeatureServerCatalogItemTraits extends mixTraits(UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits, GeoJsonTraits, FeaturePickingTraits, MinMaxLevelTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tokenUrl", _descriptor, this);
    _initializerDefineProperty(this, "token", _descriptor2, this);
    _initializerDefineProperty(this, "clampToGround", _descriptor3, this);
    _initializerDefineProperty(this, "useStyleInformationFromService", _descriptor4, this);
    _initializerDefineProperty(this, "layerDef", _descriptor5, this);
    _initializerDefineProperty(this, "where", _descriptor6, this);
    _initializerDefineProperty(this, "maxFeatures", _descriptor7, this);
    _initializerDefineProperty(this, "featuresPerRequest", _descriptor8, this);
    _initializerDefineProperty(this, "supportsPagination", _descriptor9, this);
    _initializerDefineProperty(this, "tileRequests", _descriptor0, this);
    _initializerDefineProperty(this, "clipToRectangle", _descriptor1, this);
    _initializerDefineProperty(this, "maxTiledFeatures", _descriptor10, this);
    _initializerDefineProperty(this, "featuresPerTileRequest", _descriptor11, this);
    _initializerDefineProperty(this, "maxRecordCountFactor", _descriptor12, this);
    _initializerDefineProperty(this, "supportsQuantization", _descriptor13, this);
    _initializerDefineProperty(this, "objectIdField", _descriptor14, this);
    _initializerDefineProperty(this, "outFields", _descriptor15, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "tokenUrl", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "token", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "clampToGround", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "useStyleInformationFromService", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "layerDef", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "1=1";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "where", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "1=1";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "maxFeatures", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5000;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "featuresPerRequest", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1000;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "supportsPagination", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "tileRequests", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "clipToRectangle", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "maxTiledFeatures", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100000;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "featuresPerTileRequest", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 4000;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "maxRecordCountFactor", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "supportsQuantization", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "objectIdField", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "OBJECTID";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "outFields", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ["OBJECTID"];
  }
}), _class2)) || _class);
export { ArcGisFeatureServerCatalogItemTraits as default };